import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ICategory } from 'src/app/interfaces/category';
import { Subscription as RxSubscription } from 'rxjs';

import { CategoryDataSource } from '../../services/category-data-source';

@Component({
    selector: 'category-list-dialog',
    templateUrl: 'component.html',
    styleUrls: ['component.scss'],
    standalone: false
})
export class CategoriesList implements OnInit, OnDestroy {
  public loading: boolean;
  public processListingId: number;
  public displayedColumns = ['title', 'actions'];
  private Subscriptions: RxSubscription[] = [];

  constructor(
    protected dialogRef: MatDialogRef<CategoriesList>,
    @Inject(MAT_DIALOG_DATA) public DataSource: CategoryDataSource
  ) {}

  ngOnInit() {
    this.Subscriptions.push(
      this.DataSource.loading.subscribe((loading) => (this.loading = loading))
    );
    this.DataSource.load();
  }

  public setCategory(Category: ICategory) {
    this.processListingId = Category.id;
    (
      (Category.ProductCategory && this.DataSource.delete(Category)) ||
      this.DataSource.save(Category)
    ).then(() => (this.processListingId = 0));
  }

  ngOnDestroy() {
    this.DataSource.disconnect();
    this.Subscriptions.forEach((Subscription) => Subscription.unsubscribe());
  }
}
